"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (text, maxLength, moreString = '...') => {
    return text.length > maxLength ? text.substring(0, maxLength) + moreString : text;
};
